import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import '../css/AddUnit.css';

const AddRoomType = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [formData, setFormData] = useState({
    type: ''
  });
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState({ show: false, message: '', type: '' });
  const [isEditing, setIsEditing] = useState(false);
  const [roomTypeId, setRoomTypeId] = useState(null);
  const API_URL = process.env.REACT_APP_API_URL || "";

  useEffect(() => {
    // Check if we're in edit mode
    if (location.state && location.state.roomType && location.state.isEditing) {
      const { roomType } = location.state;
      setFormData({ type: roomType.type });
      setRoomTypeId(roomType.id);
      setIsEditing(true);
    } else {
      // Reset to add mode if no edit state
      setFormData({ type: '' });
      setRoomTypeId(null);
      setIsEditing(false);
    }
  }, [location.state]);

  // Cleanup effect to reset state when component unmounts or location changes
  useEffect(() => {
    return () => {
      setFormData({ type: '' });
      setRoomTypeId(null);
      setIsEditing(false);
    };
  }, []);

  const showToast = (message, type = 'success') => {
    setToast({ show: true, message, type });
    setTimeout(() => {
      setToast({ show: false, message: '', type: '' });
    }, 3000);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const endpoint = isEditing ? "edit-room-type.php" : "add-room-type.php";
      const body = isEditing 
        ? { id: roomTypeId, type: formData.type }
        : formData;

      const response = await fetch(`${API_URL}${endpoint}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body)
      });

      const data = await response.json();

      if (data.status === 'success') {
        const action = isEditing ? "updated" : "added";
        showToast(`Room type "${formData.type}" ${action} successfully!`, 'success');
        setFormData({ type: '' });
        setTimeout(() => {
          navigate('/room-type-list');
        }, 1500);
      } else {
        showToast(data.message || `Failed to ${isEditing ? 'update' : 'add'} room type`, 'error');
      }
    } catch (err) {
      showToast('Network error. Please try again.', 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="add-unit-content">
      <div className="page-header" style={{ display: 'block' }}>
        <h1>{isEditing ? "Edit Room Type" : "Add Room Type"}</h1>
        <p>{isEditing ? "Update room type information" : "Create a new room type for your system"}</p>
      </div>

      <div className="form-container">
        <form onSubmit={handleSubmit} className="add-unit-form">
          <div className="form-group">
            <label htmlFor="type">Room Type Name *</label>
            <input
              type="text"
              id="type"
              name="type"
              value={formData.type}
              onChange={handleChange}
              placeholder="Enter room type name"
              required
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="submit-btn"
          >
            {loading 
              ? (isEditing ? 'Updating...' : 'Adding...') 
              : (isEditing ? 'Update Room Type' : 'Add Room Type')
            }
          </button>
        </form>
      </div>

      {/* Toast Notification */}
      {toast.show && (
        <div className={`toast toast-${toast.type}`}>
          <div className="toast-content">
            <span className="toast-message">{toast.message}</span>
            <button
              className="toast-close"
              onClick={() => setToast({ show: false, message: '', type: '' })}
            >
              ×
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddRoomType; 